import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "./CreateGroupModal.css";

const FileNameModal = ({
  show,
  handleClose,
  handleDownload,
  filename,
  setFilename,
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "18px" }}>Enter file name</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formFileName">
            <Form.Label>File Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter file name"
              value={filename}
              onChange={(e) => setFilename(e.target.value || "")}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
          className="cancell-button cancell-button-container"
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleDownload}
          className="create-button"
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileNameModal;
